import { useState } from "react";
import { Link } from "react-router-dom";
import S from "./style";
import { LocaleContext } from "../../locale-context";
import TranslateStatic from "../../locales/TranslateStatic";

const videoLists = {
  tr: [
    { id: "D2LrVl--QXk", title: "Fostimon TR" },
    { id: "PgJRTXlm5hk", title: "Menopur TR" },
    { id: "0dEpUkc6sfQ", title: "Meriofert TR" },
    { id: "AV4f4aBhEZY", title: "Pergoveris TR" },
    { id: "ibApofPlwFg", title: "CETROTİDE" },
    { id: "DBoqFh6U7yc", title: "OVİTRELLE" },
    { id: "8g7C6YCSJAs", title: "ORGALUTRAN" },
    { id: "0MRou2y9Y4E", title: "GONAL F" },
    { id: "ULS0oOFqvNk", title: "PUREGON TR" }
  ],
  ru: [
    { id: "-dRhSF8e7fM", title: "Fostimon RU" },
    { id: "ci17xrnyvug", title: "Pergoveris RU" },
    { id: "VFe39t31kR4", title: "Meriofert RU" },
    { id: "OevnnFDNc2o", title: "Menopur RU" },
    { id: "pD0X0DVfzxg", title: "PUREGON RU" },
    { id: "4rv83V2rsyc", title: "GONAL F RU" },
    { id: "XBgcR3IJaYU", title: "ORGALUTRAN RU" },
    { id: "Su8UhucLt9g", title: "OVİTRELLE RU" },
    { id: "XXG6XYLEKFg", title: "CETROTİDE RU" }
  ],
  en: [
    { id: "5beWrZABrEA", title: "Gonal-F EN" },
    { id: "JTHngEVxt3o", title: "Ovitrelle EN" },
    { id: "bRPNVbVaSsc", title: "Orgalutran EN" },
    { id: "u-vm95hhhvg", title: "Cetrotide EN" },
    { id: "Zf6FMpS5Njc", title: "Fostimon EN" },
    { id: "NkkvlAmug-Y", title: "Meriofert EN" },
    { id: "Igreh2-pdhA", title: "Menopur EN" },
    { id: "WJa4ZyGoacI", title: "Pergoveris EN" },
    { id: "SMQG-Pz4O4U", title: "Puregon EN" }
  ]
};
videoLists.ar = videoLists.en;
videoLists.uz = videoLists.en;

export function Ilac() {
  const [activeVideo, setActiveVideo] = useState(null);

  const renderVideos = (value) => {
    const list = videoLists[value] || videoLists.en;
    return (
      <div className="mapContainer">
        {list.map((vid, index) => (
          <div key={index} className="video-card" onClick={() => setActiveVideo(vid.id)}>
            <div className="iframe-wrapper">
              <img src={`https://img.youtube.com/vi/${vid.id}/maxresdefault.jpg`} alt={vid.title} />
              <div className="gradient-overlay"></div>
              <div className="play-button-overlay">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div className="video-title">
                <h3>{vid.title}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="IlacAnlatimiBaslik" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="IlacAnlatimiBaslik" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="gallery-container">
          <div className="intro-text">
            <p><TranslateStatic string="IlacAnlatimiMetin" /></p>
          </div>

          <LocaleContext.Consumer>
            {(value) => renderVideos(value)}
          </LocaleContext.Consumer>
        </div>
      </S.ContentWrapper>

      {activeVideo && (
        <S.ModalOverlay onClick={() => setActiveVideo(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setActiveVideo(null)}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
            <div className="modal-video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </S.ModalOverlay>
      )}
    </S.PageWrapper>
  );
}
